// extracted by mini-css-extract-plugin
export var copyableField = "_rr-4";
export var customerBadge = "_rr-0";
export var customerInfoTitle = "_rr-2";
export var details = "_rr-1";
export var dropdownContainer = "_rr-5";
export var dropdownImage = "_rr-6";
export var editAssigneeForm = "_rr-a";
export var editButton = "_rr-3";
export var email = "_rr-7";
export var hidden = "_rr-d";
export var input = "_rr-8";
export var saveButton = "_rr-b";
export var shopifyIcon = "_rr-c";
export var suggestionBadge = "_rr-e";
export var suggestionText = "_rr-f";
export var username = "_rr-9";